import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import environment from '../../../../environments/environment';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable()
export class SiteIdInterceptor implements HttpInterceptor
{

    constructor(
            private _location: Location,
            private _router: Router,
    ) {
    }

    public intercept(
            req: HttpRequest<any>,
            next: HttpHandler,
    ): Observable<HttpEvent<any>> {

        const dontAddList = [
            '.plaid.com',
        ];

        for (const toMatch of dontAddList) {
            if (req.url.indexOf(toMatch) !== -1) {
                return next.handle(req);
            }
        }

        const newReq = req.clone({
            headers: req.headers.set('X-Legfi-Site-Id', environment.SiteId.toString()),
        });

        return next.handle(newReq);
    }
}
